import { useCallback, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useAuth0Tokens = () => {
  const { getAccessTokenSilently } = useAuth0();
  const apiAudience = process.env.REACT_APP_API_AUDIENCE;
  const [token, setToken] = useState(null);

  const getTokens = useCallback(async () => {
    if (token) {
      return { apiToken: token };
    }

    try {
      // Get API token only
      const apiToken = await getAccessTokenSilently({
        authorizationParams: {
          audience: apiAudience,
          scope: 'openid profile email'
        }
      });

      setToken(apiToken);
      return { apiToken };
    } catch (error) {
      throw error;
    }
  }, [getAccessTokenSilently, apiAudience, token]);

  return { getTokens, token };
}; 